import e from"react";import t from"prop-types";import a from"styled-components";import{Fonts as o}from"@vds-core/typography";import{calculateRem as r,withVDSManager as i}from"@vds-core/utilities";import{ColorTokens as n}from"@vds-tokens/color";import{LayoutTokens as l}from"@vds-tokens/layout";import{TypographyTokens as d}from"@vds-tokens/typography";const s=n.elements.primary.onlight.value,p=n.elements.primary.ondark.value,c=d.fontweight.bold.value,u=d.fontweight.regular.value,m=r(l.space["4X"].value),g=r(l.space["3X"].value),f=r(l.space["2X"].value),y=r(l.space["1X"].value),b=r(l.space["3X"].value),h=r(l.space["2X"].value);r(19),r(14);const v={children:t.node,size:t.oneOf(["micro","bodySmall","bodyMedium","bodyLarge"]),viewport:t.oneOf(["mobile","tablet","desktop"]),ariaLabel:t.string,orderedList:t.bool,tabIndex:t.number,surface:t.oneOf(["light","dark"]),spacing:t.oneOf(["standard","compact"]),calculateLetterSpacing:t.func},L={orderedList:!1,size:"bodyLarge",viewport:"desktop",surface:"light",calculateLetterSpacing:(e,t)=>{let a="0px";return"bodyLarge"!==e&&"bodyMedium"!==e||"desktop"!==t||(a=d.letterspacing.wide.value),a}},w=a.li.withConfig({displayName:"StyledLi",componentId:"VDS__sc-mxruz8-0"})`
  ${({getFontStyles:e,size:t,viewport:a})=>e(t,a)};
  color: ${({surface:e})=>"dark"===e?p:s};
  outline: none;
  list-style: none;
  padding-top: ${({paddingTop:e})=>e};
  display: flex;

  > span {
    flex: 0 1 auto;
  }

  &:first-child {
    padding-top: 0;
  }

  > span:first-child {
    &:before {
      content: '\u2022';
      font-weight: ${c};
      padding-right: ${({paddingBullet:e})=>e};
      flex-grow: 0;
    }
  }

  ul {
    padding: 0;
    margin: 0;
    flex-shrink: 0;

    li {
      list-style: none;

      &:first-child {
        padding-top: ${({paddingTop:e})=>e};
      }

      > span:first-child {
        &::before {
          content: '\u2013';
          font-weight: ${u};
        }
      }
    }
  }
`,z=t=>{const{ariaLabel:a,children:i,size:n,viewport:l,tabIndex:s,surface:p,className:c,calculateLetterSpacing:u,spacing:v}=t,L="mobile"===l?"mobile":"desktop",z="bodyLarge"===n?m:g,$="bodyLarge"===n?f:y,k="bodyLarge"===n?b:h;return e.createElement(w,{"aria-label":a,getFontStyles:function(){return`\n    font-family: ${"bodyLarge"===n||"bodyMedium"===n?o.VerizonNHGeDS:o.VerizonNHGeTX};\n    font-size: ${r((()=>{switch(n){case"micro":return d.fontsize.micro[11].value;case"bodySmall":return d.fontsize.body[12].value;case"bodyMedium":return d.fontsize.body[14].value;case"bodyLarge":return d.fontsize.body[16].value}})())};\n      font-weight: ${d.fontweight.regular.value};\n      line-height: ${r((()=>{switch(n){case"micro":return d.lineheight.micro[16].value;case"bodySmall":return d.lineheight.body[16].value;case"bodyMedium":return d.lineheight.body[18].value;case"bodyLarge":return d.lineheight.body[20].value}})())};\n      letter-spacing: ${r(u(n,L))};\n    `},size:n,tabIndex:s,viewport:L,surface:p,className:c,paddingTop:"compact"===v?$:z,paddingBullet:k},e.createElement("span",{"aria-hidden":!0}),e.createElement("span",null,i))};z.propTypes=v,z.defaultProps=L,z.displayName="ListItem";var $=i(z);export{$ as default};
